import DomManipulate from './DomManipulate';
import Loader from '../class/Loader';
import Tooltip from '../class/Tooltip';
import LazyloadImg from '../class/LazyloadImg';
import 'whatwg-fetch'
import { select2 } from 'select2';
import 'select2/dist/css/select2.css'
import {cdn_url} from '../pages/constant'

export default class SupportedVehicles {
    constructor(selector, wrapperTable, paramIdTag, ajaxUrl) {
        this.selector = selector
        this.wrapperTable = wrapperTable
        this.paramIdTag = paramIdTag
        this.ajaxUrl = ajaxUrl
        this.userLang = document.documentElement.lang
        const noresult = {
            'en': 'No results to display',
            'fr': 'Pas de résultats à afficher'
        }
        const pages = {
          "overview_products" : {
            "en": {
              "url": "overview"
            },
            "fr": {
              "url": "sommaire"
            }
          }
        }

        this.pages = pages
        this.noresult = noresult
        this.loader = new Loader('.loaderWrapper')
    }
    init() {

        const dom = new DomManipulate()
        dom.onReady(() => {
          $('#js-feature-make').select2();
            dom.onClickAll('[' + this.selector + ']', (el) => {
                let makeid = el.getAttribute(this.selector)
                this.removeList()
                this.loader.init()
                setTimeout(() => {
                   this.getTotalCompat();
                  this.getListOfSupported(makeid);

                  if (!el.classList.contains('text-primary')) {
                    el.classList.add("text-primary")
                  }

                }, 150)
                //synchronize state with mobile selector
                $('#js-feature-make').val(makeid);
                $('#js-feature-make').trigger('change.select2');
                $('#vehicle-results').css('display', 'block');

            })
            //select

            $('#js-feature-make').on('select2:select', (e) => {
              const  data = e.params.data;
              let makeid = data.id
              let currentMake = document.querySelector('.list-multi li[data-makeid="' + makeid + '"]' );
              this.removeList()
              this.loader.init()
              setTimeout(() => {
                if (!currentMake.classList.contains('text-primary')) {
                  currentMake.classList.add("text-primary")
                }
                this.getTotalCompat();
                this.getListOfSupported(makeid)
              }, 150)
            });

            setTimeout(() => {
              $('.list-multi li:first-of-type').trigger('click');
            }, 1000)


        });

    }

    //ajax for request the list of supported for the make selected for the product / feature selected
    getListOfSupported(makeid) {
        let self = this
        let paramid = document.querySelector(this.paramIdTag).getAttribute('data-param-id')
        $.ajax({
            url: self.ajaxUrl,
            method: "POST",
            data: {
                paramid: paramid,
                makeid: makeid,
                userLang: self.userLang
            }
        }).done(function (response) {
            let txtMsg = ''
            if (response.nb_compat == 0) {
                txtMsg = self.noresult[document.documentElement.lang]
                setTimeout(() => {
                  if (!document.querySelector('.msg').classList.contains('show')) {
                    document.querySelector('.msg').classList.add("show")
                  }
                }, 150)
            }else{
              document.querySelector('.msg').classList.remove("show")
            }
            document.querySelector('.msg').innerHTML = txtMsg
            self.displayList(response)
        }).fail(function (xhr, textStatus, errorThrown) {
            console.log(textStatus)
        });
    }

  getTotalCompat() {
    let self = this
    let paramid = document.querySelector(this.paramIdTag).getAttribute('data-param-id')
    $.ajax({
      url: '/ajax/supported_vehicles_total_compat.php',
      method: "POST",
      data: {
        paramid: paramid,
        userLang: self.userLang
      }
    }).done(function (response) {
       $('#nb_compat_total_for_product').val(response.total_nb_compat)

    }).fail(function (xhr, textStatus, errorThrown) {
      console.log(textStatus)
    });
  }

    removeList() {
        let table = document.querySelector(this.wrapperTable)
        let currentMake = document.querySelector('.list-multi li.text-primary')

        if (!table || !currentMake) {
            return
        }
        if (table.classList.contains('show')) {
          table.classList.remove("show")
        }
        if (currentMake.classList.contains('text-primary')) {
          currentMake.classList.remove("text-primary")
        }
        setTimeout(() => {
          while(table.lastElementChild) {
            table.removeChild(table.lastElementChild);
          }
        }, 150)
    }

    displayList(list) {
      this.loader.remove()
      let total_compat = $('#nb_compat_total_for_product').val()
        $('.js-nb-compat').text(list.nb_compat+ "/" + total_compat)
        if (list.nb_compat == 0) {
            return
        }
        let table = document.querySelector(this.wrapperTable);
        let imgplaceholder = document.querySelector(this.paramIdTag).getAttribute('data-img-placeholder')
        let modelTrimHtml = ''
        let yearCoverage = ''

        const text_content = {
          "model" : document.querySelector(this.paramIdTag).getAttribute('data-text-model'),
          "solution": document.querySelector(this.paramIdTag).getAttribute('data-text-solution'),
          "year": document.querySelector(this.paramIdTag).getAttribute('data-text-year'),
          "tharness": document.querySelector(this.paramIdTag).getAttribute('data-text-feature-tharness'),
          "no-key-sacrificed": document.querySelector(this.paramIdTag).getAttribute('data-text-feature-no-key-sacrificed'),
          "oem-remote": document.querySelector(this.paramIdTag).getAttribute('data-text-feature-oem-remote'),
          "new-vehicles": document.querySelector(this.paramIdTag).getAttribute('data-text-new-vehicles'),
        }
        const general_content = {
          "img-tharness": document.querySelector(this.paramIdTag).getAttribute('data-img-tharness'),
          "img-check": document.querySelector(this.paramIdTag).getAttribute('data-img-check')
        }

        let template =
            `
            <h2 class="model-name">${list.make}</h2>
            <div class="bs--row table-supported__header d-none d-xl-flex">
              <div class="bs--col-xl-2">
                  <div class="table-supported__header-label font-weight-bolder text-uppercase">${text_content.model}</div>
              </div>
              <div class="bs--col-xl-2">
                  <div class="table-supported__header-label font-weight-bolder text-uppercase">${text_content.solution}</div>
              </div>
              <div class="bs--col-xl-8">
                  <div class="table-supported__header-label font-weight-bolder text-uppercase">${text_content.year}</div>
              </div>
          </div>
          <div class="table-supported__body">
          `

        for (let model in list.compat) {
          for (let trim in list.compat[model]) {
                yearCoverage = ''
                modelTrimHtml += `<div class="bs--row table-supported__row">
                                    <div class="bs--col-xl-2 d-flex">
                                        <div class="table-supported__body-label model"><div class="d-block d-xsm-inline-block">${model}</div><div class="d-block d-xsm-inline-block d-xl-none trim-mobile">${trim}</div></div>
                                    </div>
                                    <div class="bs--col-xl-2 d-none d-xl-flex">
                                        <div class="table-supported__body-label"><div>${trim}</div></div>
                                    </div>
                                    <div class="bs--col-xl-8">
                                      <div class="bs--row table-supported__year-row h-100">


                `
                for (let y = list.year_min; y <= list.year_max; y++) {
                    yearCoverage += ``
                    let coverageYearList = [];
                    for (let item in list.compat[model][trim]) {
                        let vehicleItem = list.compat[model][trim][item]
                        let year = list.compat[model][trim][item]['year']
                        coverageYearList.push(year)
                        let tooltipTemplate = `
                            <div class="tooltip-custom">
                                <div class="tooltip-header">
                                    <div class="tooltip-left-block">`
                                      if(vehicleItem.evoximage) {
                                        tooltipTemplate += `<img onerror="this.onerror=null; this.src='/dist/images/placeholders/vehicule-side.png'" src="${vehicleItem.evoximage}" class="img-fluid tooltip-vehicule-img" data-img-id="${vehicleItem.compatid}${vehicleItem.year}" alt="${vehicleItem.make} ${vehicleItem.model} ${vehicleItem.trim} ${vehicleItem.year}" data-from-evox="true">`
                                      } else if (vehicleItem.md5_image_side) {
                                          tooltipTemplate += `<img onerror="this.onerror=null; this.src='/dist/images/placeholders/vehicule-side.png'" src="${cdn_url}/images.d/md5/ffffff/${vehicleItem.md5_image_side}-120x40.jpg" class="img-fluid tooltip-vehicule-img" data-img-id="${vehicleItem.compatid}${vehicleItem.year}" alt="${vehicleItem.make} ${vehicleItem.model} ${vehicleItem.trim} ${vehicleItem.year}">`
                                      } else{
                                        tooltipTemplate += `<img src="/dist/images/placeholders/vehicule-side.png" class="img-fluid tooltip-vehicule-img" data-img-id="${vehicleItem.compatid}${vehicleItem.year}" alt="${vehicleItem.make} ${vehicleItem.model} ${vehicleItem.trim} ${vehicleItem.year}">`
                                      }
                                  tooltipTemplate += `
                                        <div class="make">${vehicleItem.make}</div>
                                        <div class="model year">${vehicleItem.model} ${vehicleItem.year}</div>
                                        <div class="trim">${vehicleItem.trim}</div>
                                        <a href="/${this.userLang}/${this.pages["overview_products"][this.userLang].url}/${vehicleItem.compatibility_url}" class="btn product">${text_content["new-vehicles"]}</a>
                                    </div>
                                    <div class="tooltip-right-block align-items-center">`;
                                  if (vehicleItem.tharness !== undefined ) {
                                    tooltipTemplate += `
                                    <div class="feature">
                                        <img width="42" heigh="42" src="${general_content["img-tharness"]}">
                                        <p class="t-harness-text">${text_content.tharness}</p>
                                    </div>`;
                                  }
                                  if (vehicleItem.no_key_sacrified === 1) {
                                    tooltipTemplate += `<div class="feature">
                                        <img width="22" heigh="22" src="${general_content["img-check"]}">
                                        <p>${text_content["no-key-sacrificed"]}</p>
                                    </div>`;
                                  }
                                  if (vehicleItem.oem_remote_support === 1) {
                                    tooltipTemplate += `<div class="feature">
                                        <img width="22" heigh="22" src="${general_content["img-check"]}">
                                        <p>${text_content["oem-remote"]}</p>
                                    </div>`;
                                  }
                                    tooltipTemplate += `</div>
                                </div>
                            </div>`;

                        let yStr = y.toString()
                        if (yStr == year) {
                            yearCoverage += `
                            <div class="bs--col-xl d-block d-xl-flex text-center table-supported__body-label position-relative">
                              <div class="d-none d-xl-block tooltip-icon stretched-link" data-vehicle-id="${vehicleItem.vehicleid}"
                                data-listener-lazy-id="${vehicleItem.compatid}${year}"
                                data-redirect="/${this.userLang}/${this.pages["overview_products"][this.userLang].url}/${vehicleItem.compatibility_url}"
                                data-tooltip="supported-vehicle-tooltip"
                                href="/${this.userLang}/${this.pages["overview_products"][this.userLang].url}/${vehicleItem.compatibility_url}">
                                ${tooltipTemplate}${year.slice(-2)}
                              </div>
                              <div class="d-block d-xl-none">
                                <a class="text-reset stretched-link" href="/${this.userLang}/${this.pages["overview_products"][this.userLang].url}/${vehicleItem.compatibility_url}">${year.slice(-2)}</a>
                              </div>
                            </div>
                            `
                        }
                    }
                    if (!coverageYearList.includes(y.toString())) {
                      yearCoverage += `<div class="bs--col-xl text-center table-supported__body-label d-none d-xl-flex h-100"><div>-</div></div>`
                    }
                    yearCoverage += ``
                }
                modelTrimHtml += `${yearCoverage}</div></div><!-- .table-supported__year-row --> </div><!-- .table-supported__row -->`
            }
        }

        template += `${modelTrimHtml}</div><!-- .table-supported__body -->`

        let tableContainer = document.querySelector(this.wrapperTable)
        tableContainer.innerHTML = template
        this.initTooltip()
        this.lazyload()
        setTimeout(() => {
          if (!table.classList.contains('show')) {
            table.classList.add("show")
          }
        }, 150)
    }

    initTooltip() {
        new Tooltip('.tooltip-custom', '/ajax/feature_benefits.php').reInit()
    }

    lazyload() {
        new LazyloadImg('.lazy-load-img', 'data-listener-lazy-id', 'data-img-id').onHoverReplaceSrcImg()
    }

};
